import React, { useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import ReviewRequestDialogContext from './ReviewRequestDialogContext';

const ReviewRequestDialogProvider = ({ children }) => {
  const [showDialog, setShowDialog] = useState(false);

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleOpenDialog = () => {
    setShowDialog(true);
  };

  const contextValue = useMemo(
    () => ({
      handleCloseDialog,
      handleOpenDialog,
      showDialog,
    }),
    [showDialog]
  );

  return (
    <ReviewRequestDialogContext.Provider value={contextValue}>
      {children}
    </ReviewRequestDialogContext.Provider>
  );
};

ReviewRequestDialogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ReviewRequestDialogProvider;
